import React from 'react';
import { Calendar, AlertCircle, Bell, Users } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 px-6 lg:px-8 bg-sky" data-id="element-109">
      <div className="max-w-5xl mx-auto text-center" data-id="element-110">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-111">
          Participa hoy en tu comunidad
        </h2>
        <p className="text-xl md:text-2xl text-white/90 mb-12 font-medium max-w-2xl mx-auto" data-id="element-112">
          Encuentra información, toma acción y mantente conectado con lo que
          pasa en tu vecindario.
        </p>

        <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-4" data-id="element-113">
          <button className="flex items-center justify-center gap-2 bg-charcoal hover:bg-charcoal-light text-white px-8 py-4 rounded-lg font-semibold transition-colors shadow-lg" data-id="element-114">
            <Calendar className="w-5 h-5" data-id="element-115" />
            Ver próxima reunión
          </button>
          <button className="flex items-center justify-center gap-2 bg-white text-charcoal hover:bg-softblue px-8 py-4 rounded-lg font-semibold transition-colors shadow-lg" data-id="element-116">
            <AlertCircle className="w-5 h-5" data-id="element-117" />
            Reportar un problema
          </button>
          <button className="flex items-center justify-center gap-2 bg-white text-charcoal hover:bg-softblue px-8 py-4 rounded-lg font-semibold transition-colors shadow-lg" data-id="element-118">
            <Bell className="w-5 h-5" data-id="element-119" />
            Recibir alertas
          </button>
          <button className="flex items-center justify-center gap-2 bg-white text-charcoal hover:bg-softblue px-8 py-4 rounded-lg font-semibold transition-colors shadow-lg" data-id="element-120">
            <Users className="w-5 h-5" data-id="element-121" />
            Contactar al comité
          </button>
        </div>
      </div>
    </section>;
}